import { Component, Input, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CarouselComponent, CarouselModule } from 'ngx-owl-carousel-o';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'calsoft-brandscarousel-type27',
  imports: [CarouselModule, MatIconModule, DefaultStyleDirective, DefaultLayoutDirective, DefaultLayoutAlignDirective, DefaultFlexDirective, CustomFlexLayoutModule],
  templateUrl: './brandscarousel-type27.component.html',
  styleUrl: './brandscarousel-type27.component.scss'
})
export class BrandscarouselType27Component {
  @Input() data: any;
  @Input() item: any;
  @Input() img: any;

  constructor( private commonService: CommonService,) { }
  
  public serverPath = environment.commonImageApi + '/home/';
  public bannerServerPath = environment.commonImageApi + '/commonSlider/';

  readonly owlCarousel = viewChild<CarouselComponent>('owlCar');

  carouselOptions = {
    loop: true, 
    margin: 10, 
    nav: false, 
    dots: true, 
    autoplay: true, 
    autoplayTimeout: 3000, 
    autoplayHoverPause: true, 
    items: 1, 
    responsive: {
      0: {
        items: 1 
      },
      600: {
        items: 1
      },
      1000: {
        items: 1 
      }
    },
    // slideBy: 1, // Slides one item at a time
    // smartSpeed: 800, // Controls the speed of the slide transition
    // rewind: true, // Rewinds to the first slide when the last slide is reached
    // animateOut: 'fadeOut', // Animation effect when a slide goes out
    // animateIn: 'fadeIn' // Animation effect when a slide comes in
  };
 
  // slides = [
  //   {
  //     title: 'Slide 1',
  //     description: 'Description for slide 1',
  //     image: 'assets/images/google-meet-people.jpg' // Update with actual image paths
  //   },
  //   {
  //     title: 'Slide 2',
  //     description: 'Description for slide 2',
  //     image: 'assets/images/seller.jpg'
  //   },
  //   {
  //     title: 'Slide 3',
  //     description: 'Description for slide 3',
  //     image: 'assets/images/Supplier-Portal-1.jpg'
  //   }
  // ];
  
   goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }
  

  link(url:any) {

    this.commonService.goToLink(url)
  }

}
